import Vue from 'vue'

export const USER_PREFERENCES_STORAGE_KEY = 'userPreferences'
const LEGACY_SENSOR_SELECTED_KEY = 'sensor_selected'

function getDefaultState() {
    return {
        peripherals: {
            temperature: null
        }
    }
}

function parseStoredPreferences() {
    try {
        const raw = localStorage.getItem(USER_PREFERENCES_STORAGE_KEY)
        if (!raw) {
            return null
        }
        return JSON.parse(raw)
    } catch {
        return null
    }
}

function persistState(state) {
    localStorage.setItem(
        USER_PREFERENCES_STORAGE_KEY,
        JSON.stringify({
            peripherals: state.peripherals
        })
    )
}

function migrateLegacySensorSelected() {
    const legacyId = localStorage.getItem(LEGACY_SENSOR_SELECTED_KEY)
    if (!legacyId) {
        return null
    }
    return { id: legacyId, name: '' }
}

function loadState() {
    const stored = parseStoredPreferences()
    const state = getDefaultState()
    let shouldPersist = false

    if (stored && stored.peripherals && typeof stored.peripherals === 'object') {
        state.peripherals = {
            ...state.peripherals,
            ...stored.peripherals
        }
    }

    if (!state.peripherals.temperature) {
        const legacyDevice = migrateLegacySensorSelected()
        if (legacyDevice) {
            state.peripherals.temperature = legacyDevice
            shouldPersist = true
        }
    }

    if (shouldPersist) {
        persistState(state)
        localStorage.removeItem(LEGACY_SENSOR_SELECTED_KEY)
    }

    return state
}

const state = loadState()

const getters = {
    getPeripheral: (state) => (type) => {
        if (!type) {
            return state.peripherals
        }
        return state.peripherals[type] || null
    }
}

const mutations = {
    setPeripheral(state, payload) {
        const type = payload && payload.type
        if (!type) {
            return
        }
        Vue.set(state.peripherals, type, payload.device || null)
        persistState(state)
    },
    clearPeripheral(state, type) {
        if (!type) {
            return
        }
        Vue.set(state.peripherals, type, null)
        persistState(state)
    }
}

const actions = {
    setPeripheral(context, payload) {
        context.commit('setPeripheral', payload)
    },
    clearPeripheral(context, type) {
        context.commit('clearPeripheral', type)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
